import { useState } from 'react';
import { faqItems } from '@/mocks/brand';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
              <a href="#faq">常见问题</a>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              关于热久久产品，您想知道的都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4">{item.question}</span>
                  <i
                    className={`ri-add-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                      openIndex === index ? 'rotate-45' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}